export default __webpack_public_path__ + "static/media/notif.71875f38.mp3";